import React, { useState, useEffect } from 'react';
import { randomString, _cs } from '@togglecorp/fujs';
import { SVGInjector } from '@tanem/svg-injector';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function Svg(props) {
  const {
    className,
    src
  } = props;
  const [id] = useState(() => `svg-${randomString(16)}`);
  const [svgId] = useState(() => `svg-${randomString(16)}`);
  useEffect(() => {
    const div = document.getElementById(id);

    if (div) {
      const svg = document.createElement('svg');
      svg.setAttribute('id', svgId);
      svg.setAttribute('class', styles.svg);
      svg.setAttribute('data-src', src);
      div.appendChild(svg);
      SVGInjector(svg);
    }

    return () => {
      const mySvg = document.getElementById(svgId);

      if (mySvg) {
        mySvg.remove();
      }
    };
  }, [id, svgId, src]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: _cs(className, styles.svgContainer)
  });
}

var Svg$1 = genericMemo(Svg);

export { Svg$1 as default };
//# sourceMappingURL=index.js.map
